import { connect } from 'react-redux'

import Pagination from 'components/pagination/Pagination';
import { getSurvey } from 'redux/actions/surveyActions';

const mapStateToProps = state => {
  return {
    page: state.survey.surveyManager.page,
    pages: state.survey.surveyManager.pages,
    pageSize: state.survey.surveyManager.pageSize,
    nbItems: state.survey.surveyManager.surveyList ? state.survey.surveyManager.surveyList.length : 0,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getNext: page => {
      const nextPage = page;

      dispatch(getSurvey({ page: nextPage }));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Pagination);



// WEBPACK FOOTER //
// src/components/survey/gestion/SurveyList/SurveyListGrid/SurveyPaginationContainer.js